import currency from "currency.js";
import { defaultNumericOpts } from "./string";

export const numericToStringThousands = (value: number) => {
  return value ? currency(value, defaultNumericOpts).format() : 0;
};

export const normalizePhoneNumber = (phone: string) => {
  let phoneNumber = phone?.toString();
  if (phoneNumber?.startsWith("08")) {
    const newphone = phoneNumber.substring(1);
    phoneNumber = `+62${newphone}`;
    return phoneNumber;
  }
  if (phoneNumber?.startsWith("8")) {
    phoneNumber = `+62${phoneNumber}`;
    return phoneNumber;
  }
  return phone;
};

export const compactNumberFormat = (number: number) => {
  const formatted = Intl.NumberFormat("id-ID", { notation: "compact" }).format(
    number
  );
  return formatted.replace(/\s+/g, "").toUpperCase();
};

export const isValidPhoneNumber = (number: any) => {
  return number !== "" && /^\d{1,13}$/.test(number);
};
